var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNaranja(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 48,
    viewBox: "0 0 72 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_602_227)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    fill: "white",
    stroke: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_602_227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 41.6989V31.1585C18.9013 31.1479 26.1138 24.0574 26.1232 15.3077V0.643517H36.8448V15.3077C36.8448 29.8582 24.8027 41.6989 10 41.6989Z",
    fill: "#FF9E16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 41.6989V31.1585C18.9013 31.1479 26.1138 24.0574 26.1232 15.3077V0.643517H36.8448V15.3077C36.8448 29.8582 24.8027 41.6989 10 41.6989Z",
    fill: "url(#paint0_linear_602_227)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7555 51.9551C55.7915 51.9567 54.8449 51.6979 54.0158 51.2059C53.1867 50.7139 52.506 50.0071 52.0455 49.1601L26.4383 2.99556C25.9906 2.17276 25.768 1.24637 25.7929 0.309988C25.8179 -0.626398 26.0895 -1.53961 26.5804 -2.3374C27.0736 -3.1371 27.7683 -3.79308 28.595 -4.23957C29.4217 -4.68606 30.3512 -4.90737 31.2904 -4.88131C32.2289 -4.85671 33.1445 -4.58589 33.9454 -4.09597C34.7462 -3.60605 35.4043 -2.91424 35.8536 -2.08988L61.4608 44.0829C61.9031 44.8945 62.1263 45.8074 62.1085 46.7315C62.0906 47.6557 61.8323 48.5592 61.3589 49.3531C60.8838 50.1487 60.2105 50.8074 59.4046 51.265C58.5988 51.7225 57.6881 51.9631 56.7614 51.9634L56.7555 51.9551Z",
    fill: "#98252B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9782 51.9634C54.1429 51.9634 51.8453 49.5758 51.8453 46.6304V0.449288C51.8453 -2.4961 54.1429 -4.88367 56.9782 -4.88367C59.8122 -4.88367 62.1098 -2.4961 62.1098 0.449288V46.6304C62.1098 49.5758 59.8122 51.9634 56.9782 51.9634Z",
    fill: "#FF5000"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 71,
    height: 47,
    rx: 5.5,
    stroke: "#DDDDDD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_602_227",
    x1: 175.521,
    y1: 860.996,
    x2: 1247.29,
    y2: 981.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9E16",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FD9516",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#F67717",
    stopOpacity: 0.31
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F05E18",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#EB4819",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E73819",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#E42C1A",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#E3251A",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#E2231A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_602_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    fill: "white",
    transform: "translate(10 -5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaranja);
export default __webpack_public_path__ + "static/media/naranja.d1caaaf357193c466e7a383dab7fd714.svg";
export { ForwardRef as ReactComponent };